import axios from "../../axios/axios";
import BasicSelect from "components/BasicInputs/BasicSelect";
import Button from "components/button/BasicButton";
import { useEffect, useState } from "react";
import { setConfirm } from "store/actions/appAction";
import { store } from "store/store";
type manageForm = {
    businesses: {
        disable: boolean,
        value: number
    },
    sourceTenant: {
        value: number
    },
    destinationTenant: {
        value: number,
        disable: boolean
    }
}
const MultiTenant = () => {
    const [sourceTenant, setSourceTenant] = useState<any[]>([])
    const [destinationTenant, setDestinationTenant] = useState<any[]>([])
    const [businesses, setBusinesses] = useState<any[]>([])
    const [manageForm, setManageForm] = useState({
        businesses: {
            disable: true,
            value: 0
        },
        sourceTenant: {
            value: 0
        },
        destinationTenant: {
            value: 0,
            disable: true
        }

    })

    const { getState, dispatch } = store
    const token = getState().businessReducer.business?.token;
    const getTenant = async () => {
        const result = await axios.get("/admin/tenant",
            {
                headers: { Authorization: `Bearer ${token}` },
            })
        const newData = result.data.data.map((x: any) => {

            return { ...x, title: `(${x.id}) ${x.url}`, ind: x.id, label: `${x.id} (${x.url})` }
        })
        setSourceTenant(newData)
        setDestinationTenant(newData)
    }
    const getBusiness = async (tenantId: number) => {
        const result = await axios.get(`/businesses/tenantBusiness?sourceId:${tenantId}`,
            {
                headers: { Authorization: `Bearer ${token}` },
            })
        const newData = result.data.data.map((x: any) => {

            return { ...x, title: `${x.id} ${x.nickName}`, ind: x.id, label: `${x.id} ${x.nickName}` }
        })
        changeDisable({ disable: false, name: "businesses" })

        setBusinesses(newData)
    }
    const onChange = (args: { val: number, name: keyof manageForm }) => {
        const { name, val } = args
        setManageForm(state => {
            return {
                ...state,
                [name]: {
                    ...state[name],
                    value: val
                }
            }
        })
    }
    const changeDisable = (args: { disable: boolean, name: keyof manageForm }) => {
        const { name, disable } = args
        setManageForm(state => {
            return {
                ...state,
                [name]: {
                    ...state[name],
                    disable
                }
            }
        })
    }
    const getBusinessDesc = (buid: number) => {
        const find = businesses.find((x: any) => x.id === buid)
        if (find)
            return find?.title
    }
    const moveData = async (confirm: boolean) => {
        if (confirm) {
            const result = await axios.post(`/core/getFromTenant?sourceId:${manageForm.sourceTenant.value}&destinationId:${manageForm.destinationTenant.value}`, {
                businessIds: [manageForm.businesses.value]

            }, {
                headers: { Authorization: `Bearer ${token}` },
            }
            )
        } else {
            dispatch(setConfirm("اخطار", () => {
                moveData(true)
            }, undefined, `شما در حال انتقال دیتای کسب و کار ${getBusinessDesc(manageForm.businesses.value)} به دیتا بیس ${manageForm.destinationTenant.value} هستید آیا ادامه میدهید؟`))
        }

    }
    useEffect(() => {

        getTenant()
        return () => {

        }
    }, [])

    return (<>
        <div className="flex bg-white p-20 flex-col gap-8" >
            <div className="w-full gap-4 flex flex-col">
                <div>
                    <BasicSelect withSearch options={sourceTenant} label=" انتخاب دیتابیس مبدا" name="sourceTenant" onChange={(val) => {
                        onChange({ name: "sourceTenant", val })
                        onChange({ name: "destinationTenant", val: 0 })
                        getBusiness(val)

                    }} />
                </div>
                <div>
                    <BasicSelect withSearch disabled={manageForm.businesses.disable} options={businesses} onChange={(val) => {
                        changeDisable({ disable: false, name: "destinationTenant" })
                        onChange({ name: "businesses", val })

                    }} label="انتخاب کسب کار" name="businesses" />
                </div>
                <div>
                    <BasicSelect withSearch disabled={manageForm.destinationTenant.disable} options={destinationTenant.filter((x: any) => x.id !== manageForm.sourceTenant.value)} label=" انتخاب دیتابیس مقصد" name="destinationTenant"
                        onChange={(val) => {
                            onChange({ name: "destinationTenant", val })

                        }}
                    />
                </div>
            </div>
            <div className="">
                <Button extraClassName="!min-w-48" className="min-w-48" onClick={() => {
                    moveData(false)
                }}>انتقال</Button>
            </div>
        </div>
    </>);
}

export default MultiTenant;